import type { DeepString } from "@/lib/i18n";

/**
 * WShopLatestProducts - stringi chrome okna (naglowek + CTA).
 * Etykiety kafelka (badge, status, cena, "do koszyka") pochodza z
 * `<ProductCard />` (wspoldzielony i18n `components/ui/ProductCard`).
 */
export const pl = {
  title: "Najnowsze produkty",
  showAll: "Zobacz wszystkie",
  noProducts: "Brak produktów.",
} as const;

export type WShopLatestProductsTranslations = DeepString<typeof pl>;
